import { Classes } from "@blueprintjs/core";
import classNames from "classnames";
import css from "./AgGridGroupHeaderRow.module.scss";
import { GroupHeaderRow, isGroupHeaderRow } from "./rowGrouping";

/**
 * The band that introduces a group of rows. Rendered as an AG Grid
 * full-width row, so it spans the table and is not tied to any column.
 */
const AgGridGroupHeaderRow: React.FC<{ row: GroupHeaderRow }> = ({
    row: { label, count }
}) => (
    <div className={css["AgGridGroupHeaderRow-root"]}>
        <span className={css["AgGridGroupHeaderRow-label"]}>{label}</span>
        <span
            className={classNames(
                css["AgGridGroupHeaderRow-count"],
                Classes.TEXT_MUTED,
                Classes.TEXT_SMALL
            )}
        >
            {count} {count === 1 ? "row" : "rows"}
        </span>
    </div>
);

export const AgGridGroupHeaderRenderer = ({
    data
}: {
    data?: object;
}): JSX.Element | null =>
    isGroupHeaderRow(data) ? <AgGridGroupHeaderRow row={data} /> : null;
